module.exports = __webpack_public_path__ + "img/jujixingchangsuo.b72efc7f.png";